export default "__VITE_ASSET__DLtgfhU8__"